export default __webpack_public_path__ + "static/media/50t.93431a8c.jpg";